import {createContext, useContext}             from "react";
import {CiffEditorContextType, defaultContext} from "./CiffEditorTypes";


export const CiffEditorContext = createContext<CiffEditorContextType>(defaultContext);

export const useCiffEditorContext = () => useContext(CiffEditorContext);
